module.exports = __webpack_public_path__ + "img/rare-6.a835be45.png";